import axiosInstance from "services/common/axiosInstance";
export interface TicketFeedbackSummaryRequest {
  from_date?: string; // e.g. "2025-11-01"
  to_date?: string;   // e.g. "2025-11-30"
}

export interface TicketCategory {
  categoryid: number;
  categoryname: string;
  priority: number; // 1 = Low, 2 = Medium, 3 = High
}

export const fetchTicketApi = async (data: any) => {
  try {
    const response = await axiosInstance.post(`/ticketing/getallticketsforadmin`,
      data,
      {
        // headers: withGuidHeader(guid),
      }
    );
    return response.data;
  } catch (error: any) {
    throw error.response?.data || error.message;
  }
};
export const deleteTicketActivityByAdminApi = async (activityId: number) => {
  try {
    const response = await axiosInstance.delete(
      `/ticketing/deleteticketactivitybyadmin`,
      {
        params: { activityid: activityId },
      }
    );
    return response.data;
  } catch (error: any) {
    throw error.response?.data || error.message;
  }
};
export const ticketReplyByAdminApi = async (data: {
  ticket_id: number;
  activity_description: string;
  status: string;
  attachment_url?: string | null;
}) => {
  try {
    const response = await axiosInstance.post(
      `/ticketing/ticketreplybyadmin`,
      data
    );
    return response.data;
  } catch (error: any) {
    throw error.response?.data || error.message;
  }
};

export const editUserApi = async (data: any) => {
  try {
    const response = await axiosInstance.post(`/usermgr/updatecustomerprofilebyadmin`,
      data,
      {
        // headers: withGuidHeader(guid),
      }
    );
    return response.data;
  } catch (error: any) {
    throw error.response?.data || error.message;
  }
};
export const fetchSingleUserApi = async (data: any) => {
  try {
    const response = await axiosInstance.post(`/reports/listallusereport`,
      data,
    );
    return response.data.users;
  } catch (error: any) {
    throw error.response?.data || error.message;
  }
};

export const deleteMultiUserApi = async (data: {}) => {
  try {
    const response = await axiosInstance.post(
      "/usermgr/changeuserstatusbyadmin",
      data,
   
    );
    return response.data;
  } catch (error: any) {
    throw error.response?.data || error.message;
  }
};

export const fetchTicketFeedbackSummaryApi = async (
  data: TicketFeedbackSummaryRequest
) => {
  try {
    const response = await axiosInstance.post(
      `/ticketfeedback/ticketfeedbacksummary`,
      data
    );
    return response.data;
  } catch (error: any) {
    throw error.response?.data || error.message;
  }
};

export interface AddTicketCategoryRequest {
  categoryname: string;
  priority: number;
}

export const addTicketCategoryApi = async (
  data: AddTicketCategoryRequest
) => {
  try {
    const response = await axiosInstance.post(
      "/ticketing/addticketcategory",
      data
    );

    // response.data.data => category_id (e.g. 1)
    return response.data;
  } catch (error: any) {
    throw error.response?.data || error.message;
  }
};

export interface UpdateTicketCategoryRequest {
  categoryid: number;
  categoryname: string;
  priority: number;
}

export const updateTicketCategoryApi = async (
  data: UpdateTicketCategoryRequest
) => {
  try {
    const { categoryid, ...payload } = data;

    const response = await axiosInstance.put(
      "/ticketing/updateticketcategory",
      payload,
      {
        params: { categoryid },
      }
    );

    return response.data;
  } catch (error: any) {
    throw error.response?.data || error.message;
  }
};

export const deleteTicketCategoryApi = async (
  categoryid: number
) => {
  try {
    const response = await axiosInstance.delete(
      "/ticketing/deleteticketcategory",
      {
        params: { categoryid },
      }
    );
    return response.data;
  } catch (error: any) {
    throw error.response?.data || error.message;
  }
};

export const fetchAllTicketCategoryApi = async (): Promise<TicketCategory[]> => {
  try {
    const response = await axiosInstance.get(
      "/ticketing/getallticketcategory_admin"
    );

    // response.data.data -> category list
    return response.data.data;
  } catch (error: any) {
    throw error.response?.data || error.message;
  }
};